const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

function getToken() {
  return localStorage.getItem('lc_token');
}

export function setSession({ token, user }) {
  localStorage.setItem('lc_token', token);
  localStorage.setItem('lc_user', JSON.stringify(user));
}

export function clearSession() {
  localStorage.removeItem('lc_token');
  localStorage.removeItem('lc_user');
}

export function getUser() {
  const raw = localStorage.getItem('lc_user');
  return raw ? JSON.parse(raw) : null;
}

async function request(path, { method = 'GET', body, auth = true } = {}) {
  const headers = { 'Content-Type': 'application/json' };
  if (auth) {
    const token = getToken();
    if (token) headers.Authorization = `Bearer ${token}`;
  }
  const res = await fetch(`${API_URL}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) {
    clearSession();
    window.location.href = '/login';
    throw new Error('unauthorized');
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `http_${res.status}`);
  return data;
}

export const api = {
  setup: (data) => request('/setup', { method: 'POST', body: data, auth: false }),
  login: (data) => request('/auth/login', { method: 'POST', body: data, auth: false }),
  me: () => request('/auth/me'),

  usuarios: () => request('/usuarios'),
  crearUsuario: (data) => request('/usuarios', { method: 'POST', body: data }),
  resetPin: (id, pin_nuevo) => request(`/usuarios/${id}/reset-pin`, { method: 'POST', body: { pin_nuevo } }),
  cambiarPin: (pin_actual, pin_nuevo) => request('/auth/cambiar-pin', { method: 'POST', body: { pin_actual, pin_nuevo } }),
  crearTenant: (data) => request('/tenants', { method: 'POST', body: data }),

  unidades: () => request('/unidades'),
  crearUnidad: (data) => request('/unidades', { method: 'POST', body: data }),

  productos: () => request('/productos'),
  crearProducto: (data) => request('/productos', { method: 'POST', body: data }),
  actualizarProducto: (id, data) => request(`/productos/${id}`, { method: 'PUT', body: data }),

  turnoAbierto: () => request('/turnos/abierto'),
  abrirTurno: () => request('/turnos/abrir', { method: 'POST', body: {} }),
  cerrarTurno: (id, conteos) => request(`/turnos/${id}/cerrar`, { method: 'POST', body: { conteos } }),

  movimientos: (turnoId) => request(`/movimientos${turnoId ? `?turno_id=${turnoId}` : ''}`),
  crearMovimiento: (data) => request('/movimientos', { method: 'POST', body: data }),

  reporteTurno: (id) => request(`/reportes/turno/${id}`),
  reporteDia: (fecha) => request(`/reportes/dia${fecha ? `?fecha=${fecha}` : ''}`),

  servicios: () => request('/servicios'),
  crearServicio: (data) => request('/servicios', { method: 'POST', body: data }),
  actualizarServicio: (id, data) => request(`/servicios/${id}`, { method: 'PUT', body: data }),

  ventasServicio: (turnoId) => request(`/ventas-servicio${turnoId ? `?turno_id=${turnoId}` : ''}`),
  crearVentaServicio: (data) => request('/ventas-servicio', { method: 'POST', body: data }),

  egresos: (turnoId) => request(`/egresos${turnoId ? `?turno_id=${turnoId}` : ''}`),
  crearEgreso: (data) => request('/egresos', { method: 'POST', body: data }),

  cuadre: (turnoId) => request(`/cuadre/${turnoId}`),

  horarioSemana: (desde, dias = 7) => request(`/horario?desde=${desde}&dias=${dias}`),
  guardarHorario: (asignaciones) => request('/horario', { method: 'PUT', body: { asignaciones } }),
  horarioActual: () => request('/horario/actual'),
  horarioActualPublico: (tenantId) => request(`/horario/actual-publico?tenant_id=${tenantId}`, { auth: false }),
};

export const FRANJAS = [
  { codigo: 'M', label: '7AM – 1PM', short: 'Mañana' },
  { codigo: 'T', label: '1PM – 7PM', short: 'Tarde' },
  { codigo: 'N', label: '7PM – 1AM', short: 'Noche' },
  { codigo: 'A', label: '1AM – 7AM', short: 'Madrugada' },
  { codigo: 'D', label: 'Descanso',  short: 'Descanso' },
];

export function getCurrentFranja(now = new Date()) {
  // UTC-5 fijo Bogotá
  const bogota = new Date(now.getTime() + (now.getTimezoneOffset() - 300) * 60000);
  const h = bogota.getHours();
  let fecha = new Date(bogota);
  let franja;
  if (h >= 7 && h < 13) franja = 'M';
  else if (h >= 13 && h < 19) franja = 'T';
  else if (h >= 19) franja = 'N';
  else if (h < 1) { franja = 'N'; fecha = new Date(bogota.getTime() - 24 * 3600 * 1000); }
  else franja = 'A';
  return { franja, fecha: fecha.toISOString().slice(0, 10) };
}
